/**
 * @generated SignedSource<<56d3acef039b910090cddecd4f25e4a8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchMercuryFocusArea_AtlassianSearchPage$data = {
  readonly __typename: string;
  readonly focusArea?: {
    readonly focusAreaType: {
      readonly id: string;
      readonly name: string;
    };
    readonly id: string;
    readonly name: string;
    readonly owner: {
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly lastModifiedDate?: string | null | undefined;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage">;
  readonly " $fragmentType": "searchMercuryFocusArea_AtlassianSearchPage";
};
export type searchMercuryFocusArea_AtlassianSearchPage$key = {
  readonly " $data"?: searchMercuryFocusArea_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchMercuryFocusArea_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchMercuryFocusArea_AtlassianSearchPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "searchMercuryFocusAreaStatusTargetDate_AtlassianSearchPage"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lastModifiedDate"
        },
        {
          "concreteType": "MercuryFocusArea",
          "kind": "LinkedField",
          "name": "focusArea",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "concreteType": "MercuryFocusAreaType",
              "kind": "LinkedField",
              "name": "focusAreaType",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ]
            },
            {
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": [
                (v1/*: any*/)
              ]
            }
          ]
        }
      ],
      "type": "SearchResultMercuryFocusArea"
    }
  ],
  "type": "SearchResult",
  "abstractKey": "__isSearchResult"
};
})();

(node as any).hash = "c84e3881069f1be8f1f3244bc1c9630e";

export default node;
